import undefinedOrNull from 'utils/undefinedOrNull';

const defaultFormatter = (v) => v;
const defaultShouldNotRender = (before, after) => undefinedOrNull(before) || undefinedOrNull(after);

const BeforeAndAfterWithArrow = ({
  label,
  before,
  after,
  valueFormatter = defaultFormatter,
  shouldNotRender = defaultShouldNotRender,
}) => {
  if (shouldNotRender(before, after)) {
    return null;
  }

  const shouldRenderArrow = !!valueFormatter(before);

  return (
    <div>
      {label}: {valueFormatter(before)}
      {shouldRenderArrow && <> &#8594;</>} {valueFormatter(after)}
    </div>
  );
};

export default BeforeAndAfterWithArrow;
